import { ChangeDetectionStrategy, Component, inject, signal, Signal, WritableSignal } from '@angular/core';
import { cardReasonMapper } from '../../application/utils';
import { GetUserPenaltiesQueryHandler, GetUserPenaltiesQueryResult } from '../../application/handlers';
import { CardReasonModel } from '../../application/interfaces';
import { PenaltyReason } from '@core-http';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-card-history',
  templateUrl: './card-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [GetUserPenaltiesQueryHandler]
})
export class CardHistoryComponent {
  private readonly getUserPenaltiesQueryHandler: GetUserPenaltiesQueryHandler = inject(GetUserPenaltiesQueryHandler);

  readonly cardReasonMapper: Record<PenaltyReason, CardReasonModel> = cardReasonMapper;
  readonly isExpanded: WritableSignal<boolean> = signal<boolean>(false);

  readonly cardHistory: Signal<GetUserPenaltiesQueryResult | undefined> = toSignal(
    this.getUserPenaltiesQueryHandler.getPenalties()
  );

  changeVisibility(): void {
    this.isExpanded.update((value: boolean) => !value);
  }
}
